import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { DataSourcesService } from '../services/data-sources.service';
import { SynchronizationProgressInfo } from '../models/synchronization-progress-info';

export const SyncStatusResolver: ResolveFn<SynchronizationProgressInfo> = (
  route: ActivatedRouteSnapshot,
): Observable<SynchronizationProgressInfo> => {
  const dataSourceService = inject(DataSourcesService);
  const companySlug = route.paramMap.get('companySlug');
  const sourceSlug = route.paramMap.get('sourceSlug');

  return dataSourceService.getSyncStatus(companySlug, sourceSlug);
};
